export const MIN_ANALYTICS_DATE = '2017-01-01';
